/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const PlaySmall = (props: any) => (
<svg {...props} viewBox="0 0 10 12" fill="inherit">
<path id="Play" fillRule="evenodd" clipRule="evenodd" d="M8.94981 7.99952C10.3501 7.10253 10.3501 4.89741 8.94981 4.00049L3.21027 0.323804C1.7902 -0.585874 0 0.529152 0 2.32331V9.67665C0 11.4709 1.7902 12.5859 3.21027 11.6762L8.94981 7.99952Z" fill="inherit"/>
</svg>);

export default PlaySmall;